import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import { X, Package, Box as BoxIcon, Boxes, ArrowLeft } from "lucide-react";
import { BaseUnitForm } from "./BaseUnitForm";
import { CompositeUnitForm } from "./CompositeUnitForm";
import { TertiaryUnitForm } from "./TertiaryUnitForm";

const modalStyle = {
  width: 800,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 0,
  maxHeight: "90vh",
  overflow: "auto",
};

export const UnitTypeModal = ({
  open,
  onClose,
  selectedType,
  onSelectType,
}) => {
  const unitTypes = [
    {
      type: "BASE",
      title: "Base Unit",
      description: "Fundamental units like piece, gram, meter",
      icon: <Package className="w-6 h-6" />,
    },
    {
      type: "COMPOSITE",
      title: "Composite Unit",
      description: "Direct conversion units like dozen (12 pieces)",
      icon: <BoxIcon className="w-6 h-6" />,
    },
    {
      type: "TERTIARY",
      title: "Tertiary Unit",
      description: "Hierarchical units like carton (24 boxes)",
      icon: <Boxes className="w-6 h-6" />,
    },
  ];

  const renderForm = () => {
    switch (selectedType) {
      case "BASE":
        return <BaseUnitForm onClose={onClose} />;
      case "COMPOSITE":
        return <CompositeUnitForm onClose={onClose} />;
      case "TERTIARY":
        return <TertiaryUnitForm onClose={onClose} />;
      default:
        return null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: modalStyle,
      }}
      sx={{
        "& .MuiDialog-paper": {
          margin: "32px",
        },
      }}>
      <div className="border-b border-gray-200">
        <div className="px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            {selectedType && (
              <IconButton
                size="small"
                onClick={() => onSelectType(null)}
                className="hover:bg-gray-100">
                <ArrowLeft size={18} />
              </IconButton>
            )}
            <Typography
              variant="h6"
              className="font-outfit font-medium text-gray-900">
              {selectedType
                ? `Create ${selectedType} Unit`
                : "Select Unit Type"}
            </Typography>
          </div>
          <IconButton size="small" onClick={onClose}>
            <X size={18} />
          </IconButton>
        </div>
      </div>

      <DialogContent className="p-6">
        {!selectedType ? (
          <div className="grid gap-4">
            {unitTypes.map(({ type, title, description, icon }) => (
              <button
                key={type}
                onClick={() => onSelectType(type)}
                className="w-full text-left p-4 rounded-lg border border-gray-200 hover:border-[#5652B0] hover:bg-purple-50 transition-colors">
                <Box className="flex items-start gap-4">
                  <div className="text-[#5652B0]">{icon}</div>
                  <div>
                    <Typography className="font-medium text-gray-800 mb-1">
                      {title}
                    </Typography>
                    <Typography variant="body2" className="text-gray-600">
                      {description}
                    </Typography>
                  </div>
                </Box>
              </button>
            ))}
          </div>
        ) : (
          renderForm()
        )}
      </DialogContent>
    </Dialog>
  );
};
